import {Component, OnInit, OnDestroy} from '@angular/core';
import {Location} from '@angular/common';
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';
import { FlexObject, AuthService, AuthStates } from 'csx-flex-ng';
import 'rxjs/add/operator/filter';
import {Menu} from './shared/menu';
import { Carousel } from 'primeng/carousel';

declare const Flex;
declare var cordova;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, OnDestroy {
    private menu = new Menu();
    counter = 0;
    menuItems = this.menu.menuItems;
    appLongName = 'System Track Works';
    appShortName = 'STW';
    needsBack = true;

    private authServiceSubscriptionRef;
    private Flex: FlexObject;


    constructor(
        private authService: AuthService,
        private _router: Router,
        private route: ActivatedRoute, 
        private location: Location
    ) {

        Carousel.prototype.onTouchStart = () => {};
        Carousel.prototype.onTouchMove = () => {};
        Carousel.prototype.onTouchEnd = () => {};   
        _router.events
            .filter(event => event instanceof NavigationEnd).subscribe((val) => {
            const path = this.location.path();
            if (path === '/main') {
                this.needsBack = false;
            } else {
                this.needsBack = true;
            }
        });

    }

    ngOnInit() {

        const urlParams = new URLSearchParams(window.location.search);
        const hasAuthParams = urlParams.has('code') && urlParams.has('state'); 
        
        if (hasAuthParams) {
            const code = urlParams.get('code');
            const state = urlParams.get('state');
            console.log('[App] Routing to login with auth params');
            this._router.navigate(['/login'], {
                queryParams: {
                code: code,
                state: state
                }
            });
        }

        this.authServiceSubscriptionRef = this.authService.isAuthorized().subscribe((authStatus) => {
            if (authStatus === AuthStates.AUTHORIZED) {
    
            } else {
                
                // Check for auth callback parameters before redirecting
                const urlParams = new URLSearchParams(window.location.search);
                const hasAuthParams = urlParams.has('code') && urlParams.has('state');
                
                if (!hasAuthParams) {
                    console.log('[App] No auth params, redirecting to login');
                    this._router.navigateByUrl('/login');
                } else {
                    console.log('[App] Auth callback detected, skipping redirect');
                }
              
            }
        });
    }
    ngOnDestroy() {
        console.log("ngOnDestroy: Unsubscribed to auth status ");
        if (this.authServiceSubscriptionRef) {
            this.authServiceSubscriptionRef.unsubscribe();
        }
    }
}
